/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Flex } from '@leverege/ui-elements'
import { useEffect, useState } from 'react'
import S from './ImagePreview.css'

function ImagePreview( { src : pSrc, delegate, dispatch, itemId, onClick } ) {
  const [ src, setSrc ] = useState()
  const [ isLoading, setIsLoading ] = useState( false )

  const loadSrc = async () => {
    try {
      setIsLoading( true )
      await dispatch(
        delegate.child( 'moldHalves' ).item( itemId ).resource( pSrc ).get(),
      ).then( ( res ) => {
        setSrc( res.data.url )
        return res
      } )
    } finally {
      setIsLoading( false )
    }
  }

  useEffect( () => {
    if ( !pSrc ) return
    loadSrc()
  }, [ pSrc ] )

  if ( isLoading ) return <Flex align='center' justify='center' className={S.image}>Loading</Flex>
  if ( src === null ) return null
  return <img src={src} onClick={onClick} className={S.image} alt='line' />
}

export default ImagePreview
